<h4>Buscar historial de un trabajador</h4>
<div class="row mb-2">
  <div class="col-md-4">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Rut trabajador</mat-label>
      <input type="text" matInput [(ngModel)]="rutBusqueda" name="rutBusqueda"
             (input)="onRutInput($event)" placeholder="Ej: 12.345.678-9" />
    </mat-form-field>
    <div *ngIf="sugerencias.length > 0" class="list-group sugerencias-trabajador">
      <button type="button" class="list-group-item list-group-item-action" *ngFor="let t of sugerencias"
              (click)="seleccionarTrabajador(t)">
        {{ t.rut | formatoRut }} - {{ t.nombres }} {{ t.apellidos }}
      </button>
    </div>
    <button mat-stroked-button color="primary" type="button" [disabled]="buscando" (click)="buscarPorRut()">
      <mat-icon>search</mat-icon>
      Buscar
    </button>
  </div>
</div>

<div *ngIf="buscado && !trabajadorSeleccionado" class="text-muted">
  No se encontró ningún trabajador con ese rut.
</div>

<div *ngIf="trabajadorSeleccionado">
  <h3>{{ trabajadorSeleccionado.nombres }} {{ trabajadorSeleccionado.apellidos }} ({{ trabajadorSeleccionado.rut | formatoRut }})</h3>
  <div *ngIf="cargandoHistorial">Cargando historial...</div>

  <table *ngIf="!cargandoHistorial" mat-table [dataSource]="historial" class="w-100">

    <ng-container matColumnDef="tipoMovimiento">
      <th mat-header-cell *matHeaderCellDef>Movimiento</th>
      <td mat-cell *matCellDef="let row">{{ row.tipoMovimiento }}</td>
    </ng-container>

    <ng-container matColumnDef="equipoHist">
      <th mat-header-cell *matHeaderCellDef>Equipo</th>
      <td mat-cell *matCellDef="let row">
        {{ row.EquipoTecnologico?.marca }} {{ row.EquipoTecnologico?.modelo }} (S/N: {{ row.EquipoTecnologico?.numeroSerie }})
      </td>
    </ng-container>

    <ng-container matColumnDef="estadoActual">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let row">
        <span [class.text-success]="row.estadoActual === 'ACTIVO'" [class.text-muted]="row.estadoActual === 'DEVUELTO'">
          {{ row.estadoActual }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaMovimientoHist">
      <th mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let row">{{ row.fechaMovimiento | date: 'dd-MM-yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="accionesHist">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent" matTooltip="Editar" (click)="abrirEditarMovimiento(row)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="primary" matTooltip="Ver PDF" (click)="verPdf(row)">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['tipoMovimiento', 'equipoHist', 'estadoActual', 'fechaMovimientoHist', 'accionesHist']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['tipoMovimiento', 'equipoHist', 'estadoActual', 'fechaMovimientoHist', 'accionesHist'];"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" colspan="5">Sin movimientos</td>
    </tr>
  </table>
</div>
